import { lazy } from 'react';

const LazyCreateFlowWizard = lazy(() => import('./create-flow-wizard'));
export default LazyCreateFlowWizard;
